export const family = {
  sans: "Inter, -apple-system, BlinkMacSystemFont, avenir next, avenir, segoe ui, helvetica neue, helvetica, Cantarell, Ubuntu, roboto, noto, arial, sans-serif",
  mono: "Menlo, Consolas, Monaco, Liberation Mono, Lucida Console, monospace",
};
